import React, { useState } from 'react';
import Switch from "react-bootstrap-switch";
import { CardBody,  Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {connect, useSelector} from "react-redux";
import { useForm } from "react-hook-form";


// components
import SelectGeneric from "../../../components/select/selectGeneric";
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";

// labels
import { LB_ACTIVE, LB_CODE } from "../../../components/i18n/i18n";
import { FL_FATHER_CATEGORY, FL_SHOW_IN_HOME } from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";


const HotelCategoryFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { userIsAdmin, filter, app } = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}
    const udn = localStorage.getItem('selectedUdn') === 'undefined' ? null : JSON.parse( localStorage.getItem('selectedUdn') );


    const [parent, setParent] = useState(filter?.item?.parent?.id);
    const [showInHome, setShowInHome] = useState(filter?.item?.showInHome != null ? filter?.item?.showInHome : null)
    const [status, setStatus] = useState(filter?.item?.status != null ? filter?.item?.status : null)
    const [resetValue, setResetvalue] = useState(false)

    const {register, handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item:{
                ...data,
                showInHome,
                status,
                udn: { id: udn?.id }
            }
        };

        if(data?.code)
            dataFilter.item.code = `%${data.code}%`

        if (parent !== undefined && parent !== null && parent !== '')
            dataFilter.item.parent = { id : parent };


        props.setFilter(path, dataFilter)
    };

    const cleanFields = () => {
        setParent(null);
        setShowInHome(null);
        setStatus(null)
        setResetvalue(!resetValue)
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <Row>
                    {
                        userIsAdmin && <Col md="3">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder="Búsqueda por código"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    }

                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_FATHER_CATEGORY}</Label>
                            <SelectGeneric
                                initialValue = { parent }
                                setExternalValue={ setParent }
                                provider={ hotelCategoryProvider }
                                customFilter={{ item: {udn: { id: udn?.id }} }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_SHOW_IN_HOME}</Label>
                            <br/>
                            <Switch 
                                animate={true} 
                                offText={"No"} 
                                onText={"Si"}
                                value={showInHome}
                                onChange={ () => setShowInHome(!showInHome) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch 
                                animate={true} 
                                offText={"No"} 
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(HotelCategoryFilters)